import React, { FunctionComponent } from "react"
import Upload from "../../../components/Upload/Upload"
import { iArtist } from "../../../definitions/Artists"

interface iProps {
  item?: iArtist
}

const ArtistUploads: FunctionComponent<iProps> = ({ item }) => {
  return (
    <div className="scrollable">
      <Upload
        name={"profileImageId"}
        fileCollection={"Files_ArtistsProfilePictures"}
        maxFiles={1}
        initialFiles={[item?.profileImageId || ""]}
        fileType={["image/png", "image/jpeg"]}
        label="Upload Image"
      />
    </div>
  )
}

export default ArtistUploads
